import Link from "next/link";
import { useRouter } from "next/router";
import { motion, AnimatePresence } from "framer-motion";

/* This example requires Tailwind CSS v2.0+ */
const steps = [
  {
    id: "Step 1",
    name: "Details",
    href: "#",
    status: "details",
    number: 1,
    active: ["details", "create-document"],
  },
  {
    id: "Step 2",
    name: "Outline",
    href: "#",
    status: "outline",
    number: 2,
    active: ["outline"],
  },
  {
    id: "Step 3",
    name: "Editor",
    href: "#",
    status: "editor",
    number: 3,
    active: ["editor"],
  },
  // {
  //   id: "Step 4",
  //   name: "Editor",
  //   href: "#",
  //   status: "editor",
  //   number: 4,
  // },
];

export default function Steps() {
  const router = useRouter();
  // return step number where step status === router.pathname
  const currentStep = steps.findIndex((step) => {
    return step.active.some((active) => router.pathname.includes(active));
  });

  return (
    <nav aria-label="Progress" className="relative">
      <div className=" pb-8 md:flex md:flex-col  md:w-44 lg:w-72 md:sticky md:top-24 left-0">
        {steps.map((step, idx) => (
          <Step
            key={`step-${idx}`}
            step={step}
            currentStep={currentStep}
            idx={idx}
          />
        ))}
      </div>
    </nav>
  );
}

function Step({ step, currentStep, idx }) {
  let status =
    currentStep === idx
      ? "active"
      : currentStep < idx
      ? "inactive"
      : "complete";

  return (
    <div className="flex space-x-6 items-center mb-8">
      <motion.div animate={status} initial={status} className="relative">
        <motion.div
          transition={rippleTransition}
          variants={rippleVariants}
          className="absolute inset-0 rounded-full"
        />

        <motion.div
          variants={backgroundVariants}
          transition={backgroundTransition}
          className="relative flex h-8 w-8 items-center justify-center rounded-full border-2 border-slate-400 bg-white font-semibold text-slate-500"
        >
          <div className="relative flex items-center justify-center">
            <AnimatePresence>
              {status === "complete" ? (
                <CheckIcon className="h-6 w-6 text-white" />
              ) : (
                <motion.span
                  key="step"
                  animate={{ opacity: 1 }}
                  exit={{ scale: 0.5, opacity: 0 }}
                  className="absolute"
                >
                  {step.number}
                </motion.span>
              )}
            </AnimatePresence>
          </div>
        </motion.div>
      </motion.div>
      <motion.span
        initial={status}
        animate={status}
        variants={textVariants}
        className="text-gray-700 font-bold text-lg capitalize tracking-wide"
      >
        {step.status}
      </motion.span>
    </div>
  );
}

function CheckIcon(props) {
  return (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={3}
    >
      <motion.path
        variants={checkIconVariants}
        transition={checkIconTransition}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5 13l4 4L19 7"
      />
    </svg>
  );
}
let x = 1;
const t = (v) => x * v;

let backgroundTransition = { duration: t(0.2) };
let backgroundVariants = {
  inactive: {
    background: "var(--white)",
    borderColor: "var(--slate-200)",
    color: "var(--slate-400)",
  },
  active: {
    background: "var(--white)",
    borderColor: "var(--green-500)",
    color: "var(--green-500)",
  },
  complete: {
    background: "var(--green-500)",
    borderColor: "var(--green-500)",
  },
};
let textVariants = {
  inactive: {
    color: "var(--slate-400)",
  },
  active: {
    color: "var(--green-500)",
  },
  complete: {
    color: "var(--slate-400)",
  },
};

let rippleTransition = {
  duration: t(0.6),
  delay: t(0.2),
  type: "tween",
  ease: "circOut",
};

let rippleVariants = {
  inactive: {
    background: "var(--green-200)",
  },
  active: {
    background: "var(--green-200)",
    scale: 1,
    transition: {
      duration: t(0.3),
      type: "tween",
      ease: "circOut",
    },
  },
  complete: {
    background: "var(--green-200)",
    scale: 1.25,
  },
};

let checkIconTransition = {
  ease: "easeOut",
  type: "tween",
  delay: t(0.2),
  duration: t(0.3),
};
let checkIconVariants = {
  complete: {
    pathLength: [0, 1],
  },
};
